import React from "react";
import { connect } from "react-redux";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Menu,
  MenuItem,
} from "@material-ui/core";
import AccountCircle from "@material-ui/icons/AccountCircle";
import useStyles from "./AppHeader.styles";
import { logout } from "../../redux/user/user.actions";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../../assets/logo1.png";

function Navbar({ logout, currentUser }) {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const classes = useStyles();
  const { t } = useTranslation();

  React.useEffect(() => {}, []);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePassowrdChangeClick = () => {
    handleClose(null);
    history.push("/change_password");
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.bar}>
        <Toolbar>
          <img
            src={logo}
            alt="Logo"
            className={classes.img}
            style={{ height: "47px" }}
            onClick={() => {
              history.push("/contracts");
            }}
          />

          <Typography variant="h6" className={classes.title}></Typography>
          {!currentUser && <div></div>}
          {currentUser && (
            <div>
              <Button
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                endIcon={<AccountCircle />}
                className={classes.noTextTransformLabel}
              >
                {currentUser.first_name + " " + currentUser.last_name}
              </Button>
              <Menu
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
              >
                <MenuItem onClick={handlePassowrdChangeClick}>
                  {t("links.Change password")}
                </MenuItem>
              </Menu>
              <Button onClick={logout} className={classes.noTextTransformLabel}>
                {t("system.logout")}
              </Button>
            </div>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
}

const mapStateToProps = ({ user }) => ({
  currentUser: user.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
